import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const PurchaseUpgradePDF = lazyWithPreload(
  () => import('./PurchaseUpgradePDF'),
)
